import React from "react";
import { Grid, Button, Box, Container } from "@mui/material";
import { ArrowRight, ArrowLeft } from '@mui/icons-material';

import LEFTIMAGE from '../../assets/Retirement Roadmap Pg3.png'
import RIGHTIMAGE from '../../assets/Retirement Roadmap Pg3 copy.png'


const PresentationTax1 = (props) => {
  return (
    <Grid>
      <Grid container>
        <Grid item xs={12} className={"top-gradient-bar bar-with-text"} >
          <Box color={'white'} style={{ color: "white", marginLeft: '15%', fontSize: '28px' }}> {"Income Tax Chart & US Debt Chart"} </Box>
        </Grid>

        <Grid item xs={6} height={'600px'}>
          <Grid container justifyContent={'right'}>
            <Grid item xs={10}>
              <img src={LEFTIMAGE} style={{ width: '90%', height: '100%' }} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6} height={'600px'} >
          <Grid container justifyContent={'left'}>
            <Grid item xs={10}>
              <img src={RIGHTIMAGE} style={{ width: '100%', height: '100%' }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} className={"plan-inputs-footer full-width"}>
        <Grid container spacing={3}>
          <Grid item xs={6} className={"left-button"}>
            <Button onClick={props.prev}><ArrowLeft />Back</Button>
          </Grid>
          <Grid item xs={6} className={"right-button"}>
            <Button onClick={props.next}>Continue<ArrowRight /></Button>
          </Grid>
        </Grid>
      </Grid>

    </Grid >
  );
};

export default PresentationTax1;
